import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";

interface RecoveredJobValue {
  job: any;
  setJob: (job: any) => void;
}

const RecoveredJobContext = createContext<RecoveredJobValue>({
  job: null,
  setJob: () => undefined,
});

export function RecoveredJobProvider(props: {
  children: ReactNode;
}): JSX.Element {
  const [job, setJobState] = useState<any>(null);
  const setJob = useCallback((next: any) => {
    setJobState((current: any) => {
      if (
        current &&
        next &&
        current.refId === next.refId &&
        current.title === next.title
      ) {
        return current;
      }
      return next;
    });
  }, []);
  return (
    <RecoveredJobContext.Provider value={{ job, setJob }}>
      {props.children}
    </RecoveredJobContext.Provider>
  );
}

export function useRecoveredJob(): RecoveredJobValue {
  return useContext(RecoveredJobContext);
}
